export function getKeys(tac_key) {
    let keys = tac_key.split("þ");
    let media_cd = "";
    let camp_seq = 0;
    let extraKey = 0;
    let ridDoc = 0;
    for (let key of keys) {
        if (key.includes("media_cd"))
            media_cd = key.split("media_cd|")[1];
        else if (key.includes("camp_seq"))
            camp_seq = Number(key.split("camp_seq|")[1]);
        else if (key.includes("extraKey"))
            extraKey = Number(key.split("extraKey|")[1]);
        else if (key.includes("ridDoc"))
            ridDoc = Number(key.split("ridDoc|")[1]);
    }

    return { media_cd, camp_seq, extraKey, ridDoc };
}